module.exports = __webpack_public_path__ + "static/media/infinity_grey_big.4963759f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/icons/infinity_grey_big.png
// module id = ./src/assets/media/icons/infinity_grey_big.png
// module chunks = 16